module.exports = __webpack_public_path__ + "static/01.34fad061.png";